document.addEventListener("DOMContentLoaded", () => {
    initCollectionSearch();
    initFilterSearch();
});

document.addEventListener("collection-grid-update", () => {
    initCollectionSearch();
    initFilterSearch();
});

function initCollectionSearch() {

    const search = document.getElementById("oneplace-search");

    if (!search || search.dataset.ready) return;

    search.dataset.ready = "1";

    search.addEventListener("input", function () {

        const value = this.value.trim().toLowerCase();

        document.querySelectorAll(".collection-grid").forEach(card => {

            const title = card.querySelector(".product-card-title");

            if (!title) return;

            const text = title.textContent.toLowerCase();

            card.style.display = text.includes(value) ? "" : "none";

        });

    });

}

function initFilterSearch() {

    document.querySelectorAll(".filter-search").forEach(input => {

        if (input.dataset.ready) return;

        input.dataset.ready = "1";

        input.addEventListener("input", function () {

            const search = this.value.toLowerCase();

            const details = this.closest("details");

            if (!details) return;

            details.querySelectorAll("li").forEach(li => {

                const text = li.textContent.toLowerCase();

                li.style.display = text.includes(search)
                    ? ""
                    : "none";

            });

        });

    });

}